import { IAvaliarTreinamentoLoteUseCase } from "../../../presentation/useCases/create/avaliar_treinamento_lote_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * AvaliarTreinamentoLoteUseCase
 */

export class AvaliarTreinamentoLoteUseCase implements IAvaliarTreinamentoLoteUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async avaliarTreinamentoLote(
    rowsSelectionModel: readonly (number | string)[],
    eficaz: number,
    avaliador: string | null,
    dataAvaliacao: Date | null,
    evidenciaObjetiva: string | null,
  ): Promise<void> {
    const idFuncionarioTreinamentosLote: number[] = [];
    for (let row of rowsSelectionModel) {
      if (typeof row === 'number') {
        idFuncionarioTreinamentosLote.push(row);
      } else if (typeof row === 'string') {
        try {
          idFuncionarioTreinamentosLote.push(Number(row));
        } catch (e) {
        }
      }
    }

    await this.repository.avaliarTreinamentoLote(
      idFuncionarioTreinamentosLote,
      eficaz,
      avaliador,
      dataAvaliacao,
      evidenciaObjetiva,
    );
  }
}